module.exports = __webpack_public_path__ + "img/V4.bfa87949.jpg";